import React, { useState, useEffect } from 'react'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { routes } from '../../../../constantes/routes'
import HospitalModal from '../HospitalModal'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import Header from '../../../header/Header'
import { hospitalsActions } from '../../../../actions/hospitalsActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import validators from '../../../../utils/validationsRegEx'
import { hospitalsTypes } from '../../../../constantes/actionTypes'
import { swalMssgs } from '../../../../constantes/swalMssgs'

const NewHospitalContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const zones = useSelector((state) => state.zones)
  const businessunits = useSelector((state) => state.businessunits)

  const [inputs, setinputs] = useState({
    codigo: '',
    nombre: '',
    direccion: '',
    poblacion: '',
    provincia: '',
    comunidad_Autonoma: '',
    pais: '',
    idioma: '',
    id_TipoZona: '',
    businessUnits: [],
  })
  const [modalIsOpen, setModalIsOpen] = useState(true) // Modal abierto por defecto

  const dispatch = useDispatch()

  const newHospital = (inputs) => dispatch(hospitalsActions.newHospital(inputs))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      dispatch(businessunitsActions.getAllBusinessUnits())
    }
  }, [])

  const closeModal = () => {
    setModalIsOpen(false)
    history.push(routes.HOSPITALS)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      // Transformar businessUnits (array de IDs) a id_NegocioUnidades para el backend
      const { businessUnits, ...hospitalDataBase } = inputs
      const hospitalData = {
        ...hospitalDataBase,
        id_NegocioUnidades: businessUnits || [],
      }

      const response = await newHospital(hospitalData)
      if (hospitalsTypes.NEW_HOSPITAL_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const handleBusinessUnitsChange = (selectedBusinessUnitIds) => {
    setinputs((inputs) => ({
      ...inputs,
      businessUnits: selectedBusinessUnitIds,
    }))
  }

  const validateForm = () => {
    // console.log('inputs', inputs)
    return (
      validators.hasValue(inputs.nombre) &&
      validators.hasValue(inputs.codigo) &&
      validators.hasValue(inputs.poblacion) &&
      inputs.businessUnits.length > 0
    )
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <HospitalModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            inputs={inputs}
            zones={zones}
            businessunits={businessunits}
            handleChange={handleChange}
            handleBusinessUnitsChange={handleBusinessUnitsChange}
            handleSubmit={handleSubmit}
            validateForm={validateForm}
            textBtn={onSubmitText.Crear}
            isEdit={false}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}
export default withRouter(NewHospitalContainer)
